export { default } from './RelatedItemsConstructor.vue'
